import { useEffect, useRef, useState } from "react";
import ChevronDown from "../../assets/svg/chevron-down";
import LockIcon from "../../assets/svg/lock-icon";
import PolygonIcon from "../../assets/svg/polygon-icon";
import "./login-header-dropdown.scss";
import config from "../../config";
import { useAppSelector } from "../../redux/hook";
import { PersonIcon } from "../../assets/svg";

interface loginHeaderDropdownProps {
  isAuth: boolean;
  onClick: any;
}

export default function LoginHeaderDropdown({ ...props }: loginHeaderDropdownProps) {
  // Desired behaviour:
  // 1. If the button is clicked, always show
  // 2. If the button is not clicked, show only when hover
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isShowingDropdown, setIsShowingDropdown] = useState(false); // toggled by click
  const loginHeaderDropdownRef = useRef<HTMLDivElement>(null);
  const loginName = useAppSelector((state) => state.auth.AuthenticationSlice.loginUser.name);
  const spcpName = useAppSelector((state) => state.auth.AuthenticationSlice.spcpName);
  const name = (!spcpName ? loginName : spcpName);

  const handleOutsideClick = (event: MouseEvent) => {
    if (loginHeaderDropdownRef.current?.contains(event.target as Node)) return;
    setIsShowingDropdown(false);
  };

  useEffect(() => {
    setIsLoggedIn(props.isAuth);
  }, [props.isAuth]);

  useEffect(() => {
    window.addEventListener("click", handleOutsideClick);
    return () => {
      window.removeEventListener("click", handleOutsideClick);
    };
  }, []);

  return !isLoggedIn ? (
    
    <div className={`old-header-login-button-container text-decoration-none ${isShowingDropdown ? "showing-dropdown" : ""}`} ref={loginHeaderDropdownRef}>
      <button
        className="old-header-login-button"
        onClick={() => setIsShowingDropdown((prev) => !prev)}
      >
        <div className="old-header-login-icon old-header-login-icon-lock">
          <LockIcon />
        </div>
        <div className="old-header-login-text text-decoration-none">Login</div>
        <div className="old-header-login-icon">
          <ChevronDown />
        </div>
      </button>

      <div className="old-header-items-container">
        <div className="old-header-dropdown old-header-border-red ">
          <div className="old-header-dropdown-inner">
            <div className="old-header-dropdown-section">
              <a href={config.myHdbLoginURL} className="old-header-dropdown-section-link">
                Login to My HDBPage
              </a>
              <div className="old-header-dropdown-separator" />
              {/* <a href={"https://services2.hdb.gov.sg/webapp/FI10PPORTAL/FI10PAtAGlance.jsp"} className="old-header-dropdown-section-link">Login to My HDBPage</a> */}
              <a href={"https://services2.hdb.gov.sg/webapp/FI10AWBIZ/FI10PBizOverview.jsp"} className="old-header-dropdown-section-link">
                Login to My Business
              </a>
            </div>
          </div>
        </div>
        <div className="arrow-up" />
      </div>
    </div>
  ) : (
    <div className={`old-header-login-button-container text-decoration-none ${isShowingDropdown ? "showing-dropdown" : ""}`} ref={loginHeaderDropdownRef}>
      <button className="old-header-login-button" onClick={() => setIsShowingDropdown((prev) => !prev)}>
        <div className="old-header-login-icon old-header-login-icon-person">
          <PersonIcon size={20} />
        </div>
        <div className="old-header-login-text text-decoration-none truncate">{name?.length > 8 ? name.substring(0, 8) : name}...</div>
        <div className="old-header-login-icon">
          <ChevronDown />
        </div>
      </button>
      <div className="old-header-items-container">
        <div className="old-header-dropdown old-header-border-red">
          <div className="old-header-dropdown-inner">
            <div className="old-header-dropdown-section">
              <a className="old-header-dropdown-section-link" href="#">
                <PersonIcon size={14} />
                <span className="truncate" style={{ width: "99%" }}>
                  {name}
                </span>
              </a>
              <div className="old-header-dropdown-separator" />
              <a href={config.myHdbLoginURL} className="old-header-dropdown-section-link">
                Login to My HDBPage
              </a>
              <div className="old-header-dropdown-separator" />
              {/* <a href={"https://services2.hdb.gov.sg/webapp/FI10PPORTAL/FI10PAtAGlance.jsp"} className="old-header-dropdown-section-link">Login to My HDBPage</a> */}
              <a href={"https://services2.hdb.gov.sg/webapp/FI10AWBIZ/FI10PBizOverview.jsp"} className="old-header-dropdown-section-link">
                Login to My Business
              </a>
              <div className="old-header-dropdown-separator" />
              <button className="old-header-dropdown-section-link" onClick={props.onClick}>
                <LockIcon />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
        <div className="arrow-up" />
      </div>
    </div>
  );
}
